// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"db85faa1","container":"b0ca5f98","name":"d2d7ddfa","position":"af87950d","picture":"b92a2d15"};